<template>
    <div class="login-page">
        <div id="button"></div>
        <p v-if="googleLoginUnavailable" class="login-fallback">Google 登录暂不可用，请稍后刷新页面重试。</p>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            googleLoginUnavailable: false,
        }
    },
    mounted() {
        if (typeof google === 'undefined' || !google?.accounts?.id?.renderButton) {
            this.googleLoginUnavailable = true;
        } else {
            google.accounts.id.renderButton(
                document.getElementById('button'),
                {type: 'standard', theme: 'outline'}
            )
        }
    },
}
</script>

<style scoped>
.login-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 80px;
}

.login-fallback {
    color: #606266;
    font-size: 14px;
}
</style>
